
(function () {
   const duration = 0.3;
   const ease = 'power3.out';
   const swipeThreshold = 50;

   function init() {
      const root = document.getElementById('steps-slider');
      if (!root || root.dataset.stepsInit || typeof gsap === 'undefined') return;

      const panels = Array.from(root.querySelectorAll('[data-steps-panel]'));
      const images = Array.from(root.querySelectorAll('[data-steps-image]'));
      const thumbs = Array.from(root.querySelectorAll('[data-steps-thumb]'));
      const stage = root.querySelector('[data-steps-stage]');
      const nextButton = root.querySelector('[data-steps-next]');
      if (panels.length < 2) return;

      root.dataset.stepsInit = 'true';

      let current = 0;
      let animating = false;

      function goTo(index, direction) {
         const target = (index + panels.length) % panels.length;
         if (animating || target === current) return;

         animating = true;
         const dir = direction || (target > current ? 1 : -1);
         const outPanel = panels[current];
         const inPanel = panels[target];

         gsap
            .timeline({
               onComplete() {
                  animating = false;
               },
            })
            .set(inPanel, { yPercent: 100 * dir, visibility: 'visible' }, 0)
            .to(outPanel, { yPercent: -100 * dir, duration: duration, ease: ease }, 0)
            .to(inPanel, { yPercent: 0, duration: duration, ease: ease }, 0)
            .to(images[current], { autoAlpha: 0, duration: duration, ease: 'power2.inOut' }, 0)
            .to(images[target], { autoAlpha: 1, duration: duration, ease: 'power2.inOut' }, 0)
            .set(outPanel, { visibility: 'hidden' });

         current = target;

         thumbs.forEach(function (thumb, i) {
            thumb.toggleAttribute('data-active', i === current);
            thumb.setAttribute('aria-current', i === current ? 'true' : 'false');
         });
      }

      if (nextButton) {
         nextButton.addEventListener('click', function () {
            goTo(current + 1, 1);
         });
      }

      thumbs.forEach(function (thumb, i) {
         thumb.addEventListener('click', function () {
            goTo(i, i > current ? 1 : -1);
         });
      });

      // touch swipe, since the next arrow is desktop only
      let startX = 0;
      let startY = 0;
      let tracking = false;

      stage.addEventListener(
         'pointerdown',
         function (event) {
            if (event.pointerType === 'mouse') return;
            tracking = true;
            startX = event.clientX;
            startY = event.clientY;
         },
         { passive: true }
      );

      stage.addEventListener(
         'pointerup',
         function (event) {
            if (!tracking) return;
            tracking = false;

            const dx = event.clientX - startX;
            const dy = event.clientY - startY;
            if (Math.abs(dx) < swipeThreshold || Math.abs(dx) < Math.abs(dy)) return;

            const dir = dx < 0 ? 1 : -1;
            goTo(current + dir, dir);
         },
         { passive: true }
      );

      stage.addEventListener(
         'pointercancel',
         function () {
            tracking = false;
         },
         { passive: true }
      );
   }

   if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
   } else {
      init();
   }

   document.addEventListener('shopify:section:load', function (event) {
      if (event.detail.sectionId === sectionId) init();
   });
})();
